export default __webpack_public_path__ + "static/media/bg80.35ae1174.webp";